module.exports = __webpack_public_path__ + "img/20201204_134139.4da54af5.jpg";